// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QFPG","top":"styles_top__2DcK-"};